// extracted by mini-css-extract-plugin
export default {"inline":"xLFLDM","block":"_Zr4Ou","hiddenNode":"t2_Jl3"};